import { PaymentPlanHistoryItem, PaymentPlanInvoiceStatus } from '@frontend/api-payment-plans';

export const isPlanScheduled = ({ payment }: PaymentPlanHistoryItem) =>
  payment?.status === PaymentPlanInvoiceStatus.Scheduled ||
  payment?.status === PaymentPlanInvoiceStatus.Paused ||
  payment?.status === PaymentPlanInvoiceStatus.Canceled;
